import { Tag as TagComponent } from '@factorialco/deprecated-design-system'

import { formatValue } from 'modules/core/components/ActivityLog/Log/functions'
import { ChangeValue } from 'modules/core/components/ActivityLog/Log/types'

interface Props {
  value: ChangeValue
  isOldValue: boolean
}

export const Tag = ({ value, isOldValue }: Props) => {
  return (
    <TagComponent
      icon="add"
      leftItem="circle"
      showCircle
      size="normal"
      type={isOldValue ? 'grey' : 'viridian'}
    >
      {formatValue(value.value)}
    </TagComponent>
  )
}
